import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import Test from './test';
// import reportWebVitals from './reportWebVitals';

// Render the App component into the root element.
// Authentication part can be handled here. On Login, render App, else render Login component.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div style={{height:"110vh"}}>
    <App />
  </div>
);


